export default __webpack_public_path__ + "static/media/shoes1-afterA-1920w.f6701a6e.avif";